export default __webpack_public_path__ + "locales/sl/Article.json?hash=3c46a05190df2b87ee50113b45af37cb";